export class StsUser {
    id: string;
    userName: string;
    password: string;
    hasEmailChanged : boolean;
    personalEmail: string;
}
